/**
 * VersionUpdatedLegalDocument
 *
 * Identifies which legal document a Remote Config `version*` push has just
 * updated, so the app can tell the user that document changed.
 *
 * Mirrors Flutter's `VersionUpdatedLegalDocument`
 * (lib/domain/enums/version_updated_legal_document.dart:1-9) — all 7 members in
 * Flutter's exact ordinal order.
 *
 * Members are string-valued (rather than Dart's implicit ordinals) so a value
 * is safe to use directly as a React key and to put in a Redux action payload,
 * and so a persisted/logged value stays readable if the member order ever
 * changes.
 *
 * Deliberately **no** user-facing labels here: Flutter carries them on the
 * `userFriendlyValue` extension
 * (lib/domain/enums/version_updated_legal_document.dart:11-30), but on the web
 * every user-facing string is l10n (en + ro), so the per-member label is a
 * presentation-layer lookup — `useExpauseLocalizations.getLegalDocumentLabel`
 * (presentation/locale/expauseLocalizations.ts).
 */
export enum VersionUpdatedLegalDocument {
  termsOfService = 'termsOfService',
  coinsPolicy = 'coinsPolicy',
  communityGuidelines = 'communityGuidelines',
  exclusiveSubscriptionsPolicy = 'exclusiveSubscriptionsPolicy',
  premiumSubscriptionsPolicy = 'premiumSubscriptionsPolicy',
  privacyPolicy = 'privacyPolicy',
  rewardsPolicy = 'rewardsPolicy',
}
